import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigProvider} from "../base/config";
import {Observable} from "rxjs/Observable";
import {map} from "rxjs/operators";

/*
 Generated class for the ExameProvider provider.

 See https://angular.io/guide/dependency-injection for more info on providers
 and Angular DI.
 */
@Injectable()
export class ExameProvider {

    public ressourceUrl: any = ConfigProvider.host + '/api/v1/front/saude/exame';

    constructor(public http: HttpClient) {
    }

    create(data, params: any = {}, headers: HttpHeaders = null): Observable<any> {
        return this.http.post(this.ressourceUrl, data, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    list(params: any = {}, headers: HttpHeaders = null): Observable<any> {
        return this.http.get(this.ressourceUrl, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    agendar(exameId, data, params: any = {}, headers: HttpHeaders = null): Observable<any> {
        return this.http.post(this.ressourceUrl + '/realizar-agendamento/' + exameId, data, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    reagendar(exameId, horarioId, agendamentoId, params: any = {}, headers: HttpHeaders = null): Observable<any> {
        return this.http.get(this.ressourceUrl + '/realizar-reagendamento/' + exameId + '/' + horarioId + '/' + agendamentoId, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    comfirmarPresenca(exameServicoId, idExame, params: any = {}, headers: HttpHeaders = null): Observable<any> {

        return this.http.get(this.ressourceUrl + '/confirmar-presenca/' + exameServicoId + '/' + idExame, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                return response;
            })
        );

    }

    pagamento(idExame, data, params: any = {}, headers: HttpHeaders = null): Observable<any> {

        return this.http.post(this.ressourceUrl + '/pagamento/' + idExame, data, {

            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                return response;
            })
        );

    }

    cancelar(exameId, horarioId, agendamentoId, params: any = {}, headers: HttpHeaders = null): Observable<any> {
        return this.http.get(this.ressourceUrl + '/cancelar-agendamento/' + exameId + '/' + horarioId + '/' + agendamentoId, {
            params: params,
            headers: headers
        }).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    nextPage(_url: string = ""): Observable<any> {

        let options = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Enctype': 'application/json'
            }
        };

        return this.http.get(_url, options);
    }
}



// WEBPACK FOOTER //
// ./src/providers/exame/exame.ts